import React from 'react';
import styles from './barcode.module.css'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'; 
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PrintRoundedIcon from '@material-ui/icons/PrintRounded';
import Barcode  from 'react-barcode';
import List from '@material-ui/core/List'
import ViewWeekIcon from '@material-ui/icons/ViewWeek';
import Tooltip from '@material-ui/core/Tooltip'


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BarCodeComp = (props) => {
    const [open,setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <Tooltip title="View Barcode">
                <IconButton onClick={() => setOpen(true)}> 
                    <ViewWeekIcon />
                </IconButton>
            </Tooltip>
            <div className={styles.container}>
                <Dialog fullScreen open={open} onClose={() => setOpen(false)} TransitionComponent={Transition}>
                    <AppBar className={styles.appBar}>
                        <Toolbar className={styles.toolBar}>
                            <div className={styles.leftContent}>
                                <IconButton edge="start" color="inherit" onClick={() => setOpen(false) } aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={styles.title}>
                                    {props.location.name}
                                </Typography>
                            </div>
                            <Button autoFocus endIcon={<PrintRoundedIcon />} onClick={() => window.print()}>Print</Button>
                        </Toolbar>
                    </AppBar>
                    <List>
                    <div className={styles.container}>
                        <div className={styles.barcode}>
                            <Barcode value={props.location.location_barcode} />

                            <p>Warehouse: {props.warehouse.name}</p>
                            <p>Godown: {props.location.godown.name}</p>
                            <p>Location: {props.location.name}</p>
                        </div>
                    </div>
                    </List>
                </Dialog>
            </div>
        </React.Fragment>
    )
}

export default BarCodeComp;